// @flow

import * as React from "react";
import { Reference } from "react-popper";
import cx from "classnames";

import styles from "./Trigger.scss";
import ControlledTriggerIcon from "../ControlledTriggerIcon";
import type { ControlledTriggerIconTypes } from "../ControlledTriggerIcon/ControlledTriggerIcon";

type TriggerProps = {
  triggerRef: {
    current: null | HTMLDivElement
  },
  setIsOpen: (isOpen: boolean) => void,
  onClick: () => void,
  additionalStyles: { trigger: string },
  type: ControlledTriggerIconTypes
};

const blurButton = e => {
  e.currentTarget.blur();
};

const Trigger = ({ triggerRef, setIsOpen, onClick, additionalStyles, type }: TriggerProps) => (
  <Reference>
    {({ ref }) => (
      <div ref={triggerRef}>
        <button
          type="button"
          className={cx(...[styles, additionalStyles].map(c => c.trigger))}
          onClick={onClick}
          ref={ref}
          onFocus={() => setIsOpen && setIsOpen(true)}
          onBlur={() => setIsOpen && setIsOpen(false)}
          onMouseLeave={blurButton}
          aria-label="Tooltip"
          data-testid="trigger"
        >
          <ControlledTriggerIcon type={type} />
        </button>
      </div>
    )}
  </Reference>
);

Trigger.defaultProps = {
  triggerRef: {
    current: null
  },
  setIsOpen: () => null,
  onClick: () => null,
  additionalStyles: {
    trigger: ""
  }
};

export default Trigger;
